"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const shoponlinebrand04 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 72 56",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-shoponlinebrand04` : '') + (description ? ` desc-shoponlinebrand04` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-shoponlinebrand04"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-shoponlinebrand04"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#dsoinvruwef)"
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "b48jsdlkv74",
    style: {
      "maskType": "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "73",
    height: "56"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M72.03.04h-72v55h72v-55Z",
    fill: "#fff"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#b48jsdlkv74)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M62.26 3.9c1.69 0 3.06 1.34 3.06 2.99v17.92l-.08.17h4.64a2.2 2.2 0 0 1 2.21 2.19v25.31a2.2 2.2 0 0 1-2.21 2.19H57.9a2.2 2.2 0 0 1-2.21-2.19v-6.77H41.28v8.6h5.66c.21 0 .37.16.37.37 0 .18-.13.33-.31.36H22.42c-.21 0-.37-.16-.37-.37 0-.18.13-.33.31-.36H27.88v-8.6H7.11c-1.69 0-3.06-1.34-3.06-2.99V6.89c0-1.65 1.37-2.99 3.06-2.99h55.15Z",
    fill: "#F1C4DC",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M52.65 43.81H4.06C1.82 43.81 0 42.02 0 39.82V3.99C0 1.79 1.82 0 4.06 0h55.15c2.24 0 4.06 1.79 4.06 3.99v17.92c0 .55-.45 1-1 1s-1-.45-1-1V3.99c0-1.1-.93-1.99-2.06-1.99H4.06C2.92 2 2 2.89 2 3.99v35.83c0 1.1.93 1.99 2.06 1.99h48.58c.55 0 1 .45 1 1s-.45 1-1 1h.01Z",
    fill: "#D01481"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.44 31.03c-1.02 0-1.94-.76-2.13-1.8l-1.71-11.7c-.04-.7.19-1.3.63-1.73.43-.43 1.04-.65 1.64-.61h15.36c.55-.04 1.15.19 1.58.61.44.43.67 1.03.64 1.64L39.74 29.2c-.19 1.09-1.12 1.87-2.23 1.83H25.43h.01Zm-1.65-13.84c-.08 0-.12.02-.15.04s-.04.06-.04.1l1.69 11.58c.01.06.1.12.19.12H37.59c.09 0 .17-.06.19-.15l1.7-11.63s-.02.01-.05-.02c-.03-.03-.08-.04-.12-.04H23.79Z",
    fill: "#D01481"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M34.65 16.9c-.47 0-.89-.33-.98-.81-.2-1.01-1.11-1.75-2.16-1.75-1.04 0-1.95.74-2.15 1.74-.11.54-.64.89-1.18.78a.997.997 0 0 1-.78-1.18c.39-1.93 2.11-3.34 4.11-3.35 2.01 0 3.75 1.42 4.12 3.37a.994.994 0 0 1-.79 1.17c-.06.01-.13.02-.19.02v.01ZM31.53 27.88c-.4 0-.79-.17-1.07-.45l-2.99-3.04a2.698 2.698 0 0 1 0-3.78c.98-1.02 2.8-1.02 3.78 0l.29.29.29-.3c.97-1 2.79-1.01 3.78 0a2.717 2.717 0 0 1 0 3.78l-3 3.05c-.28.28-.67.45-1.07.45h-.01Zm-2.18-6.07c-.17 0-.34.07-.45.19-.27.28-.27.72 0 .99l2.63 2.68 2.63-2.68c.26-.27.26-.71 0-.99a.653.653 0 0 0-.9 0l-1.01 1.03c-.38.38-1.05.38-1.43 0l-1-1.02a.62.62 0 0 0-.46-.19l-.01-.01ZM25.51 52.76c-.55 0-1-.45-1-1V42.8c0-.55.45-1 1-1s1 .45 1 1v8.96c0 .55-.45 1-1 1ZM37.77 52.76c-.55 0-1-.45-1-1V42.8c0-.55.45-1 1-1s1 .45 1 1v8.96c0 .55-.45 1-1 1Z",
    fill: "#D01481"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M43.89 52.76H19.38c-.55 0-1-.45-1-1s.45-1 1-1h24.51c.55 0 1 .45 1 1s-.45 1-1 1ZM66.84 52.76H54.85c-1.77 0-3.21-1.43-3.21-3.19V24.26c0-1.76 1.44-3.19 3.21-3.19h11.99c1.77 0 3.21 1.43 3.21 3.19v25.31c0 1.76-1.44 3.19-3.21 3.19ZM54.85 23.07c-.67 0-1.21.53-1.21 1.19v25.31c0 .66.54 1.19 1.21 1.19h11.99c.67 0 1.21-.53 1.21-1.19V24.26c0-.66-.54-1.19-1.21-1.19H54.85Z",
    fill: "#D01481"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M69.05 47.09h-16.4c-.55 0-1-.45-1-1s.45-1 1-1h16.4c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "#D01481"
  }))), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "dsoinvruwef"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h72.1v55.04H0z"
  }))));
};
var _default = exports.default = shoponlinebrand04;